<template>
  <b-modal
    size="small"
    :is-open="$store.isOpen"
    :is-closable-by-user="false"
  >
    <template v-if="$store.isFirstAcceptance">
      <h2 class="use-terms-banner-modal__title">
        Termos e Condições de Uso
      </h2>

      <b-text class="use-terms-banner-modal__body mt-4">
        Li e estou ciente com os Termos e Condições de Uso da Buser
      </b-text>
    </template>

    <template v-else>
      <h2 class="use-terms-banner-modal__title">
        Termo atualizado
      </h2>

      <b-text class="use-terms-banner-modal__body mt-4">
        Olá parceiro, atualizamos nossos {{ termTypeLabel.toLowerCase() }}.
      </b-text>

      <b-text
        color="grey"
        size="small"
        class="use-terms-banner-modal__date mt-2"
      >
        Atualizado em {{ publishedAtLabel }}
      </b-text>
    </template>

    <div class="use-terms-banner-modal__actions mt-6">
      <b-button
        v-if="!$store.isFirstAcceptance"
        variant="text"
        @click="handleViewTerm"
      >
        Visualizar termo
      </b-button>

      <b-button
        :disabled="$store.isSubmitting"
        @click="handleAccept"
      >
        {{ $store.isFirstAcceptance ? 'Ciente' : 'Estou ciente' }}
      </b-button>
    </div>
  </b-modal>
</template>

<script setup>
import { computed } from 'vue';
import { useTermsBannerStore } from '@stores';
import { COMPANY_TERMS_TYPE_DICTIONARY } from '@utils/dictionary/company-terms-dictionary';
import { getDate } from '@utils/date/get-date';

const $store = useTermsBannerStore();

const termTypeLabel = computed(() => (
  $store.term ? COMPANY_TERMS_TYPE_DICTIONARY[$store.term.term_type] || 'Termo ' : ''
));

const publishedAtLabel = computed(() => (
  $store.term ? getDate($store.term.last_published_at) : ''
));

const handleViewTerm = () => {
  if ($store.term?.url) {
    window.open($store.term.url, '_blank', 'noopener,noreferrer');
  }
};

const handleAccept = () => {
  $store.accept();
};
</script>

<style lang="scss">
.use-terms-banner-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--size-scalable-small);
}
</style>
